// extracted by mini-css-extract-plugin
export var collection_header = "PdpAdsCollection-module--collection_header--39663";
export var collection_header__productsSort = "PdpAdsCollection-module--collection_header__products-sort--8d3c0";
export var collection_header_right = "PdpAdsCollection-module--collection_header_right--86306";
export var collection_products = "PdpAdsCollection-module--collection_products--331bd";
export var collection_products__load_more_button_container = "PdpAdsCollection-module--collection_products__load_more_button_container--58323";
export var content_collection = "PdpAdsCollection-module--content_collection--16f05";
export var filters = "PdpAdsCollection-module--filters--e8954";